// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"MyAddress_menuItem__1cYCd","menuName":"MyAddress_menuName__3nVUO","avatar":"MyAddress_avatar__1bcy2"};